"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _reactIntl = require("react-intl");

var _theming = _interopRequireDefault(require("../../../utils/theming"));

var _MenuItemContent = _interopRequireDefault(require("./MenuItemContent"));

var _messages = require("../../../constants/messages");

var _components = require("../../../components");

var _Button = _interopRequireDefault(require("@match/react-component-library/components/Button"));

var _VisuallyHidden = _interopRequireDefault(require("@match/react-component-library/components/VisuallyHidden"));

var MenuItem = function MenuItem(_ref) {
  var altCountUI = _ref.altCountUI,
      activeHoverListItem = _ref.activeHoverListItem,
      _ref$as = _ref.as,
      as = _ref$as === void 0 ? 'li' : _ref$as,
      buttonClassName = _ref.buttonClassName,
      children = _ref.children,
      className = _ref.className,
      customLinkRenderer = _ref.customLinkRenderer,
      hideLabel = _ref.hideLabel,
      icon = _ref.icon,
      id = _ref.id,
      label = _ref.label,
      isSelected = _ref.isSelected,
      route = _ref.route,
      showIndicatorDot = _ref.showIndicatorDot,
      count = _ref.count,
      noSelectionUnderline = _ref.noSelectionUnderline,
      onMouseEnter = _ref.onMouseEnter,
      onMouseLeave = _ref.onMouseLeave,
      subMenuUI = _ref.subMenuUI,
      props = (0, _objectWithoutProperties2.default)(_ref, ["altCountUI", "activeHoverListItem", "as", "buttonClassName", "children", "className", "customLinkRenderer", "hideLabel", "icon", "id", "label", "isSelected", "route", "showIndicatorDot", "count", "noSelectionUnderline", "onMouseEnter", "onMouseLeave", "subMenuUI"]);
  var isExpanded = subMenuUI ? activeHoverListItem === id : undefined;
  var showMenuIndicatorDot = showIndicatorDot && !isSelected;
  var ariaSelected = isSelected ? 'true' : undefined;

  var handleMouseEnter = function handleMouseEnter() {
    if (onMouseEnter) {
      onMouseEnter(id);
    }
  };

  var handleMouseLeave = function handleMouseLeave() {
    if (onMouseLeave) {
      onMouseLeave(id);
    }
  };

  var handleKeyPress = function handleKeyPress(e) {
    if (e.keyCode === 27) {
      // escape
      handleMouseLeave();
    }

    if (e.keyCode === 32) {
      // space
      e.preventDefault();

      if (isExpanded) {
        handleMouseLeave();
      } else {
        handleMouseEnter();
      }
    }
  };

  var handleClick = function handleClick(e) {
    e.preventDefault();

    if (isExpanded) {
      handleMouseLeave();
    } else {
      handleMouseEnter();
    }
  };

  return _react.default.createElement(FocusBox, {
    "aria-expanded": isExpanded,
    "aria-selected": ariaSelected,
    as: as,
    className: className,
    "data-uia-link": props['data-uia-link'],
    isSelected: activeHoverListItem === id,
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
    onKeyDown: handleKeyPress,
    role: "listitem"
  }, subMenuUI && _react.default.createElement(_VisuallyHidden.default, null, _react.default.createElement(_Button.default, {
    "aria-expanded": isExpanded,
    "aria-haspopup": "true",
    onClick: handleClick,
    tabIndex: -1
  }, isExpanded ? _react.default.createElement(_reactIntl.FormattedMessage, {
    id: _messages.MESSAGE_ID.CLOSE_SUBMENU
  }) : _react.default.createElement(_reactIntl.FormattedMessage, {
    id: _messages.MESSAGE_ID.OPEN_SUBMENU
  }))), _react.default.createElement(_components.LinkRenderer, {
    customLinkRenderer: customLinkRenderer,
    routeHref: route
  }, _react.default.createElement(_MenuItemContent.default, {
    buttonClassName: buttonClassName,
    children: children,
    count: count,
    hideLabel: hideLabel,
    icon: icon,
    isSelected: isSelected,
    label: label,
    noSelectionUnderline: noSelectionUnderline,
    showMenuIndicatorDot: showMenuIndicatorDot
  })), altCountUI, subMenuUI);
};

var FocusBox = (0, _theming.default)('li')(function (_ref2) {
  var _ref3;

  var isSelected = _ref2.isSelected;
  return _ref3 = {
    display: 'flex',
    height: '100%',
    position: 'relative'
  }, (0, _defineProperty2.default)(_ref3, 'ul', {
    display: isSelected ? 'block' : 'none',
    opacity: 0.95,
    height: 'auto',
    visibility: 'visible'
  }), (0, _defineProperty2.default)(_ref3, 'a:focus+ul', {
    display: isSelected ? 'block' : 'none'
  }), (0, _defineProperty2.default)(_ref3, ':hover', (0, _defineProperty2.default)({}, 'ul', {
    display: isSelected ? 'block' : 'none'
  })), _ref3;
});
var _default = MenuItem;
exports.default = _default;